export const TimerReset = (props: any) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3.41797" y="3.41797" width="13.1641" height="13.1641" rx="0.9375" fill="white" />
    </svg>
  );
};
